import { Link } from 'react-router-dom';
import { ButtonBase, Tooltip } from '@mui/material';

const LogoSection = () => (
  <Tooltip title="Home" arrow>
    <ButtonBase
      disableRipple
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <img
        src={`/asset/SHIP-03.png`}
        alt={'logo_PTT'}
        loading="lazy"
        width={'180'}
        style={{ display: 'block' }}
      />
    </ButtonBase>
  </Tooltip>
);

export default LogoSection;
